"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.fixOversizeElement = fixOversizeElement;
exports.scaleContainer = scaleContainer;
exports.scaleFontSize = scaleFontSize;
var _react = require("react");
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
require("intersection-observer");
function useMobileLayout(_ref) {
  var ref = _ref.ref,
    handlers = _ref.handlers,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _react.useEffect)(function () {
    if (ref && ref.current) {
      var observer = new IntersectionObserver(function (entries) {
        return requestAnimationFrame(function () {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0) return;
            var target = entry.target;
            var context = new Map();
            context.set('target', target);
            context.set('parent', target.parentElement);
            handlers.forEach(function (fn) {
              return fn(context, options);
            });
          });
        });
      });
      observer.observe(ref.current);
      return function () {
        observer.disconnect();
      };
    }
  }, deps);
}
function fixOversizeElement(context) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var target = context.get('target');
  var parent = context.get('parent');
  if (!target || !parent) return;
  var elementsWithWidth = target.querySelectorAll('[width], [style]');
  for (var i = 0, length = elementsWithWidth.length; i < length; i++) {
    var element = elementsWithWidth[i];
    var width = element.style.width || element.style.minWidth || element.width;
    if (width && !isRelativeValue(width) && parseInt(width) > parent.clientWidth) {
      element.style.width = '100%';
    }
  }
}
function scaleContainer(context) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var target = context.get('target');
  var parent = context.get('parent');
  if (!target || !parent) return;
  var _getComputedStyle = getComputedStyle(target),
    paddingLeft = _getComputedStyle.paddingLeft,
    paddingRight = _getComputedStyle.paddingRight;
  var xPadding = parseFloat(paddingLeft) + parseFloat(paddingRight);
  var childWidth = target.scrollWidth;
  var parentWidth = parent.clientWidth;
  var ratio = parentWidth / (childWidth + xPadding);
  if (ratio < 1) {
    target.style.transform = "scale(".concat(ratio, ")");
    target.style.transformOrigin = 'top left';
  }
  context.set('ratio', ratio);
}
var ATTR_MODIFIED = 'modified';
var FONT_SIZE_ATTR = 'data-font-size';
var LINE_HEIGHT_ATTR = 'adata-line-height';
function scaleFontSize(context) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ratio = context.get('ratio') || 1;
  var target = context.get('target');
  if (!target) return;
  var _opts$maxFontSize = opts.maxFontSize,
    maxFontSize = _opts$maxFontSize === void 0 ? 17 : _opts$maxFontSize;
  var elements = target.querySelectorAll('[style]');
  var scale = 1.0 / ratio;
  for (var i = 0, length = elements.length; i < length; i++) {
    var element = elements[i];

    // Font Size
    var fontSizeModified = element.getAttribute(FONT_SIZE_ATTR) === ATTR_MODIFIED;
    var fontSize = element.style.fontSize;
    if (!!fontSize && !fontSizeModified && parseInt(fontSize) < maxFontSize * scale) {
      var nextSize = calculateSize(fontSize, scale, maxFontSize);
      if (nextSize) {
        element.style.fontSize = nextSize;
        element.setAttribute(FONT_SIZE_ATTR, ATTR_MODIFIED);
      }
    }

    // Line Height
    var lineHeightModified = element.getAttribute(LINE_HEIGHT_ATTR, ATTR_MODIFIED);
    var lineHeight = element.style.lineHeight;
    if (!!lineHeight && !lineHeightModified) {
      var _nextSize = calculateSize(lineHeight, scale);
      if (_nextSize) {
        element.style.lineHeight = _nextSize;
        element.setAttribute(LINE_HEIGHT_ATTR, ATTR_MODIFIED);
      }
    }
  }
}
var _default = exports["default"] = useMobileLayout; // Function `calculateSize` and `isRelativeValue` are both
// Referred from EdoEmailFormatter.swift
function calculateSize(s, scale, max) {
  var newSize = '';
  var unit = '';
  var maxSize = max || Infinity;
  if (s.endsWith('px')) {
    unit = 'px';
  } else if (s.endsWith('pt')) {
    unit = 'pt';
    maxSize = maxSize * 0.75;
  } else if (s.endsWith('cm')) {
    unit = 'cm';
    maxSize = maxSize / 37.8;
  } else if (s.endsWith('mm')) {
    unit = 'mm';
    maxSize = maxSize / 3.78;
  } else if (s.endsWith('in')) {
    unit = 'in';
    maxSize = maxSize / 96;
  } else if (s.endsWith('pc')) {
    unit = 'pc';
    maxSize = maxSize / 16;
  }
  s = parseFloat(s);
  if (!isNaN(s) && unit) {
    if (maxSize) {
      newSize = Math.min(s, maxSize) * scale + unit;
    } else {
      newSize = s * scale + unit;
    }
  }
  return newSize;
}
function isRelativeValue(s) {
  if (!s || (0, _isNumber["default"])(s)) {
    return false;
  }
  return s.endsWith('em') || s.endsWith('rem') || s.endsWith('ch') || s.endsWith('vw') || s.endsWith('%');
}
//# sourceMappingURL=mobileLayout.js.map